import { i18n as _i18n } from "@lingui/core";
import { BaseField } from './BaseField';
import { selectFieldRenderer } from './fieldRenderers/selectFieldRenderer';
import { useSyncValues } from './hooks/useAutoSelectForDataFields';
import { useStateMachineForFields } from './hooks/useStateMachineForFields';
import { jsx as _jsx } from "react/jsx-runtime";
export function QuestionnaireSelect(_ref) {
  let {
    name,
    label,
    answers,
    placeholder = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.placeholder.questionnaireField'
    }),
    mktSelector = {
      value: label,
      group: false
    },
    isHiddenField,
    onFieldEnabled,
    onChange,
    ...props
  } = _ref;
  const {
    isFieldEnabled,
    sendUserSelect,
    stateFieldClassNames
  } = useStateMachineForFields({
    name
  });
  const options = answers.map(_ref2 => {
    let {
      value,
      label
    } = _ref2;
    return {
      value,
      label
    };
  });
  useSyncValues(name);
  return /*#__PURE__*/_jsx(BaseField, {
    label: label,
    name: name,
    MktSelector: mktSelector,
    topContainerClassName: stateFieldClassNames,
    disabled: !isFieldEnabled,
    isHiddenField: isHiddenField,
    onFieldEnabled: onFieldEnabled,
    renderFieldComponent: _ref3 => {
      let {
        name,
        ...rest
      } = _ref3;
      return selectFieldRenderer({
        id: name,
        name,
        placeholder,
        options,
        disabled: !isFieldEnabled,
        onChange: e => {
          onChange?.(e);
          sendUserSelect(e.target.value);
        },
        ...rest
      });
    },
    ...props
  });
}

/** @deprecated Export with typo, Use {@link QuestionnaireSelect} */
export const QuestionaireSelect = QuestionnaireSelect;